import { connect } from 'react-redux';
import { useEffect } from 'react';
import * as actionTypes from '../../redux/actionTypes';
import config from '../../appConfig';
import AlertIcon from '../../_styles/images/AlertIcon.png';
import Close from '../../_styles/images/close-icon-green.svg';
import Callable from '../../shared/Callable';

function FedMilPopup(props) {



function addSecondaryCard() {
    props.history.push('/JoinCommute/add-payment/backup')
}

function changeStartDate() {
   props.history.push('/JoinCommute/payment/changeStarDate')
}

  return (
    <div className="charges-popup show" id='fedmil-popup' aria-live='polite' role='alert' aria-modal='true' tabIndex={0}>
    <div className='fedmil-container'>
        <div className="fedmil-modal-container">
            <div className='top-header'>
                <button
                    role='button'
                    className="close traditional"
                     onClick={() => props.close(false)}
                    // onKeyDown={updatePVPKeydown}
                    tabIndex={0}
                    aria-label="Close popup"
                >
                    <img src={Close} alt='Close' />
                </button>

            </div>
            <div className="sp-header">

                <div className='header'>
                    <div className='van-image'>
                        <img src={AlertIcon} alt='van' />
                    </div>
                    <div className='heading'>
                    Your benefit card won’t cover your first prorated payment
                    </div>
                </div>
            </div>
            <div className='fedmil-popup-container'>
                <div className='content'>
                    <div className='first-section'>
                    To proceed you can either change your start date to when your benefit card will have sufficient funds, or you can add a secondary payment card to cover the first month's cost.
                    </div>
                </div>
                <div className="pre-text">
                        If you have any questions, please call <Callable className="greentext" phone="800 VAN-4-WORK" />
                </div>
            </div>
            <div className='button-container'>
                <button tabIndex={0}  className="secondaryCard" onClick={addSecondaryCard}>Add Secondary Card</button>
                <button tabIndex={0}  className="startdate" onClick={changeStartDate}>Change Start Date</button>
            </div>

        </div>
    </div>
</div>
  );
}


export default connect(
  null,
  null
)(FedMilPopup);
